module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Glass-martini-6ca7e36695eb8370542f6894a51074dc.svg";